// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"style_formWrapper__1KEnm","form":"style_form__12F3u","row":"style_row__y38qv","form__message":"style_form__message__3T-ok","form__errors":"style_form__errors__17Rsh"};